import moment from "moment";
import React, { useState } from "react";
import { Card, CardBody } from "reactstrap";
import { Tooltip } from "@mui/material";

import { EyeIcon } from "../../masters/studentFinancials/paymentCollection/manage-receipts/EyeIcon";
import {
  capitalize,
  fetchAllPostPromisedData,
} from "../../common/utils/methods/commonMethods/utilityMethod";
import ADataGrid from "views/pages/manage/common/data-grid/ADataGrid";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import { updateRequest } from "views/pages/manage/edpOps/constant/common";
import { AGridColDef } from "views/pages/manage/common/data-grid/ADataGridColDef";
import { failureToast } from "../../common/utils/methods/toasterFunctions/function";

import {
  ViewUserMappingPopover,
  getFormattedDate,
  LastUpdatedDetails,
  REACT_ICONS_STYLE,
  TableHeaderActions,
  DEFAULT_FILTER_STATE,
  searchEmployeeDetails,
  SEARCH_BY,
} from "./helper";
import AChip from "../../common/chip/AChip";
import APopover from "../../common/a-popover";
import { endpoint } from "../../common/constant";
import { BsThreeDotsVertical } from "react-icons/bs";
import AInput from "../../common/formFeilds/customInput/AInput";
import UserFilters from "./UserFilters";
import { maskEmail } from "../../unAssigned/collectPayment/selectPaymentMode/paymentLink/utils";

const UserListing = ({
  rows,
  isLoading,
  setIsLoading,
  rowCount,
  currentPage,
  populateUserListing,
  userPermissions,
}) => {
  const [filterCount, setFilterCount] = useState(0);
  const [filters, setFilters] = useState({
    searchBy: "",
    searchByValue: "",
    ...DEFAULT_FILTER_STATE,
  });

  const [userSearchInput, setUserSearchInput] = useState("");
  const [selected, setSelected] = useState("employeeName");

  const openInNewTab = (url) => {
    window.open(window.location.origin + "/#/admin/" + url, "_blank").focus();
  };

  const menuItems = [
    // userPermissions.includes("C")
    //   ? {
    //       text: "Add new user",
    //       handleClick: () => {
    //         openInNewTab("userProfile/new");
    //       },
    //     },   // {
    //   text: "HONO Sync",
    //   handleClick: () => {},
    // }
    //   : [],
    {
      text: "Export CSV",
      handleClick: () => {
        downloadCsv();
      },
    },
  ];

  const columns = [
    new AGridColDef("employeeId", "Employee ID")
      .setMinWidth(125)
      .renderCellComponent((params) =>
        params?.value ? (
          <span
            onClick={() => {
              params.row?.isUserProfileCreated &&
                openInNewTab(`userProfile/view/${params?.value}`);
            }}
            style={{
              cursor: params.row?.isUserProfileCreated
                ? "pointer"
                : "not-allowed",
            }}
            className="text-primary text-sm"
          >
            {params.value}
          </span>
        ) : (
          <div>-</div>
        )
      ),

    new AGridColDef("employeeName", "Full Name")
      .setMinWidth(160)
      .renderCellComponent((params) =>
        params?.value ? (
          params.value.length > 19 ? (
            <Tooltip title={params.value}>
              <span>{params.value.substr(0, 17)}...</span>
            </Tooltip>
          ) : (
            params.value
          )
        ) : (
          <div>-</div>
        )
      ),

    new AGridColDef("ticketDate", "Date")
      .setMinWidth(120)
      .renderCellComponent((params) =>
        params?.value ? (
          <Tooltip title={getFormattedDate(params?.value)}>
            <div className="ellipsis-text-container">
              {getFormattedDate(params?.value)}
            </div>
          </Tooltip>
        ) : (
          <div className="m-auto">-</div>
        )
      ),

    new AGridColDef("isUserProfileCreated", "User ID", false)
      .setMinWidth(80)
      .renderCellComponent((params) => {
        return params.value ? (
          <ViewUserMappingPopover
            userId={params.row.employeeId}
            emailId={params.row.email}
          />
        ) : (
          <div style={{ color: "#AFAFAF" }}>N/A</div>
        );
      }),

    // new AGridColDef("project", "Project", false)
    //   .setMinWidth(150)
    //   .renderCellComponent((params) =>
    //     params.row ? params.value : <div>N/A</div>
    //   ),

    new AGridColDef("designation", "Designation")
      .setMinWidth(135)
      .renderCellComponent((params) => (
        <Tooltip title={params?.value}>
          <span>{params?.value || "-"}</span>
        </Tooltip>
      )),

    new AGridColDef("department", "Department")
      .setMinWidth(130)
      .renderCellComponent((params) =>
        params.value?.length > 15 ? (
          <Tooltip title={params.value}>
            <span>{params.value.substr(0, 13)}...</span>
          </Tooltip>
        ) : (
          params.value || "-"
        )
      ),

    new AGridColDef("email", "Email Address")
      .setMinWidth(200)
      .renderCellComponent((params) =>
        params?.value ? (
          <div className={`ellipsis-text-container`}>
            {maskEmail(params?.value)}
          </div>
        ) : (
          <div>-</div>
        )
      ),

    new AGridColDef("region", "Region")
      .setMinWidth(100)
      .renderCellComponent((params) => (
        <Tooltip title={params?.value}>
          <span>{params?.value || "-"}</span>
        </Tooltip>
      )),

    new AGridColDef("joiningDate", "Joining Date")
      .setMinWidth(130)
      .renderCellComponent((params) =>
        params?.value ? (
          <Tooltip title={getFormattedDate(params?.value)}>
            <div className="ellipsis-text-container">
              {getFormattedDate(params?.value)}
            </div>
          </Tooltip>
        ) : (
          <div className="m-auto">-</div>
        )
      ),

    new AGridColDef("source", "Source")
      .setMinWidth(120)
      .renderCellComponent((params) => (
        <Tooltip title={params?.value}>
          <span>{params?.value || "-"}</span>
        </Tooltip>
      )),

    new AGridColDef("updatedOn", "Last updated on")
      .setMinWidth(200)
      .renderCellComponent((params) =>
        params?.value ? (
          <Tooltip
            title={LastUpdatedDetails(params?.value, params?.row.updatedBy)}
          >
            <div className={`ellipsis-text-container`}>
              {LastUpdatedDetails(params?.value, params?.row.updatedBy)}
            </div>
          </Tooltip>
        ) : (
          <div>-</div>
        )
      ),

    new AGridColDef("status", "Emp Status")
      .setMinWidth(120)

      .renderCellComponent((params) => (
        <div style={{ position: "fixed" }}>
          <AChip
            label={capitalize(params?.value)}
            success={params.value.toUpperCase() === "ACTIVE"}
          />
        </div>
      )),

    new AGridColDef("action", "Action", false)
      .setMinWidth(170)
      .pinColumnLast(true)
      .renderCellComponent((params) => {
        return (
          <div>
            {!params?.row.isUserProfileCreated ? (
              <AButton
                variant="primary_filled"
                size="xs"
                onClick={() => {
                  openInNewTab("userProfile/new");
                }}
                disabled={["inactive", "resigned"].includes(
                  params?.row?.status.toLowerCase()
                )}
              >
                Give Access
              </AButton>
            ) : (
              <>
                <AButton
                  variant="outline"
                  size="xs"
                  className="px-4 w-100"
                  onClick={() => {
                    openInNewTab(`userProfile/edit/${params?.row.employeeId}`);
                  }}
                  disabled={!userPermissions.includes("U")}
                >
                  Edit
                </AButton>

                <Tooltip title="View">
                  <span
                    onClick={() => {
                      openInNewTab(
                        `userProfile/view/${params?.row.employeeId}`
                      );
                    }}
                    style={{
                      cursor: "pointer",
                    }}
                    className="ml-2"
                  >
                    <EyeIcon />
                  </span>
                </Tooltip>
              </>
            )}
          </div>
        );
      }),
  ];

  const structurePayload = (filters) => {
    const payloadWithIds = updateRequest(filters);
    return {
      ...payloadWithIds,
      ...(filters.joiningDateFrom && {
        joiningDateFrom: new Date(filters.joiningDateFrom).toISOString(),
      }),
      ...(filters.joiningDateTo && {
        joiningDateTo: new Date(
          moment(filters.joiningDateTo).endOf("day")
        ).toISOString(),
      }),
    };
  };

  const fetchUsers = async ({ request = filters, page = 0 }) => {
    setIsLoading(true);
    const payload = structurePayload(request);

    const response = await searchEmployeeDetails({ payload, page });
    populateUserListing(response);
    setIsLoading(false);
  };

  const downloadCsv = async () => {
    const payload = structurePayload(filters);
    setIsLoading(true);

    try {
      const resp = await fetchAllPostPromisedData(
        `${endpoint.searchEmployeeDataToCsv}`,
        payload
      );

      if (resp?.code === 200) {
        const { data } = resp;

        const templateUrl = await fetchAllPostPromisedData(
          `${endpoint.fetchS3Url.getDownloadUrl}?key=${data}`,
          {}
        );
        if (templateUrl?.code === 200 && templateUrl?.data) {
          window.open(`${templateUrl?.data?.url}`);
        } else {
          failureToast("Something went wrong! Please try after sometime.");
        }
      }
    } catch (err) {
      console.log(err);
    }

    setIsLoading(false);
  };

  const onPageChange = (page) => {
    fetchUsers({ page });
  };

  const applyFilters = (f) => {
    const updatedFilters = { ...filters, ...f };
    setFilters(updatedFilters);

    fetchUsers({ request: updatedFilters, page: 0 });
  };

  const searchInputHandler = (value = userSearchInput) => {
    const updatedFilters = {
      ...filters,
      searchBy: value ? selected : "",
      searchByValue: value,
    };
    setFilters(updatedFilters);

    fetchUsers({
      request: updatedFilters,
      page: 0,
    });
  };

  const onKeyDownHandler = (e) => {
    if (e.key === "Enter" || e.keyCode === 13) {
      searchInputHandler();
    }
  };

  // const crossInputHandler = () => {
  //   setFilters({ ...globalFilter, ...emptySearchFields });
  //   updateReceiptsList(emptySearchFields);
  // };

  const handleOnUserInput = (value) => {
    setUserSearchInput(value);
    if (value === "" && value !== filters.searchByValue)
      searchInputHandler(value);
  };

  return (
    <div>
      <Card className="mx-3 flex-glow-1">
        <CardBody className="d-flex flex-column pb-0">
          <div className="search-match-container">
            <div className="heading-3 color-black-60 text-bold">
              List of users
            </div>

            <div className="d-flex align-items-center mb-2">
              <AInput
                placeholder="Search"
                className=""
                value={userSearchInput}
                handler={handleOnUserInput}
                onKeyDown={onKeyDownHandler}
                searchIconClickHandler={() => {
                  searchInputHandler();
                }}
                crossIcon={false}
                searchIcon={true}
                style={{ width: "300px" }}
                customSearchIconStyle={{ left: "5px" }}
                rightCustomIconStyles={{
                  fontSize: "12px",
                  position: "absolute",
                  bottom: "7px",
                  right: "113px",
                  margin: "auto",
                }}
                rightCustomIcon={
                  <select
                    value={selected}
                    onChange={(e) => setSelected(e.target.value)}
                    style={{
                      position: "absolute",
                      bottom: "0",
                      margin: "auto 0",
                      background: "#FFF6E3",
                      color: "#A17217",
                      border: "none",
                    }}
                  >
                    {SEARCH_BY.map(({ key, value }) => (
                      <option value={key}>{value}</option>
                    ))}
                  </select>
                }
              />

              <APopover
                buttonComponent={(onClick, styles) => (
                  <AButton
                    className="tiny-semi-bold color-dark"
                    disabled={isLoading}
                    onClick={onClick}
                    updatedStyle={{
                      minWidth: "61px",
                      ...(filterCount > 0
                        ? {
                            border: "1px solid #00B0F5",
                            color: "#00B0F5",
                          }
                        : styles),
                    }}
                  >
                    Filters {filterCount > 0 && <>( {filterCount} )</>}
                  </AButton>
                )}
                menuComponent={(closeForm) => (
                  <>
                    <UserFilters
                      closeForm={closeForm}
                      applyFilters={applyFilters}
                      filters={filters}
                      setFilterCount={setFilterCount}
                      filterCount={filterCount}
                    />
                  </>
                )}
                maxHeight={"calc(100vh - 180px)"}
              />

              <APopover
                buttonComponent={(onClick, styles) => (
                  <Tooltip title="More Actions">
                    <AButton
                      className="tiny-semi-bold color-dark"
                      disabled={isLoading}
                      onClick={onClick}
                    >
                      <BsThreeDotsVertical style={REACT_ICONS_STYLE} />
                    </AButton>
                  </Tooltip>
                )}
                menuComponent={(closeForm) => (
                  <TableHeaderActions
                    handleClose={closeForm}
                    menuItems={menuItems}
                  />
                )}
                sx={{
                  "& .MuiPaper-root": {
                    border: `1px solid #E2E2E2`,
                    boxShadow: "0px 3px 4px 0px #00000014 !important",
                    borderRadius: "8px",
                  },
                }}
                // transformOriginVertical="center"
                // transformOriginHorizontal="left"
              />
            </div>
          </div>

          <ADataGrid
            rows={rows}
            columns={columns}
            rowId={(row) => row.id}
            // loading={isLoading}
            //   emptyRowPlaceholder={() => <NoReceiptsFound />}
            rowCount={rowCount}
            nextButtonHandler={(page) => {
              onPageChange(page);
            }}
            currentPage={currentPage}
            pinLastColumn
            height="500px"
          />
        </CardBody>
      </Card>
    </div>
  );
};

export default UserListing;
